<template>
  <div class="Application">
    <mt-header :title="caseguid==null?'新申请':caseNumber" class="mtheader">
      <router-link to="/History.html" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <div class="info">
      <my-reject v-show="reject_info!=null && reject_info.length>0" :arr="reject_info"></my-reject>
      <h5>申请人信息</h5>
      <div>
        <mt-field
          label="姓名"
          placeholder="请输入您真实名字"
          v-model="person_info.username"
        ></mt-field>
        <mt-field
          label="手机号码"
          placeholder="请输入手机号码"
          type="tel"
          v-model="person_info.tel"
        ></mt-field>
        <div style="position:relative;">
          <mt-field label="证件类型"></mt-field>
        <my-picker
            :value="person_info.cardtype"
            :arr="cardtypeArr"
            @bindChange="cardtypeChange"
            :placeholder="'请选择证件类型'"
          ></my-picker>
        </div>
        <mt-field
          label="证件号"
          placeholder="请输入证件号"
          v-model="person_info.cardNo"
        ></mt-field>
      </div>
    </div>
    <div class="info">
      <h5>翻译文件信息</h5>
      <div style="background-color: white">
        <div style="position:relative;">
          <mt-field label="文件类型"></mt-field>
          <my-picker
            :value="trans_file_info.type"
            :arr="trantypeArr"
            @bindChange="trantypeChange"
            :placeholder="'请选择翻译件类型'"
          ></my-picker>
        </div>
        <div style="position:relative;">
          <mt-field label="原件语种"></mt-field>
           <my-picker
            :value="trans_file_info.lan"
            :arr="lanArr"
            @bindChange="tranlanChange"
            :placeholder="'请选择翻译件语种'"
          ></my-picker>
        </div>
        <div class="big-ceil">
          <div class="subtitle">拍照上传需要翻译的文件</div>
          <div class="tips">
            （建议使用手机拍照扫描功能或者使用“<span @click="toMiniProgram"
              >扫描全能王小程序</span
            >”）
          </div>
          <mt-popup
            v-model="issm"
            position="bottom"
            popup-transition="popup-fade"
            class="pop-sm"
          >
            <img src="../assets/images/smqnewm.png" width="200" height="200" />
            <p>请长按识别小程序码</p>
          </mt-popup>
          <div class="img-content">
            <div class="imglist">
              <div style="position:relative;" v-show="trans_file_info.filesList.length > 0" v-for="f in trans_file_info.filesList"
                :key="f.guid">
                <img
                :src="f.url"
                width="72"
                height="72"
                @click="previewImg(f.url)"
              />
              <img @click="deleImg(f.guid)" style="position:absolute;top:0;right:0;" src="../assets/images/dele-icon.png" width="20" height="20">
              </div>
              <div>
              <img
              class="photo-icon"
              src="../assets/images/add.png"
              width="72"
              height="72"
              @click="chooseImg"
            />
            </div>
            </div>
          </div>
        </div>
        <div class="big-ceil">
          <div class="subtitle">翻译备注</div>
          <div class="tips">
            （请标注出哪些姓名或公司名，需要翻译成指定的中文）
          </div>
          <textarea
            id="text-area"
            rows="4"
            v-model="trans_file_info.tranbz"
            placeholder="请输入备注"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="info">
      <h5>邮寄地址</h5>
      <div style="background-color: white;">
        <mt-field
          label="姓名"
          placeholder="请输入收件人姓名"
          type="text"
          v-model="post_info.name"
        ></mt-field>
        <mt-field
          label="手机号码"
          placeholder="请输入收件人手机号"
          type="tel"
          v-model="post_info.tel"
        ></mt-field>
        <mt-field
          label="详细地址"
          placeholder="请输入收件详细地址"
          type="text"
          v-model="post_info.address"
        ></mt-field>
      </div>
    </div>
    <div class="pinfo">
      <h5>电子发票</h5>
      <div>
        <mt-field
          label="发票类型"
          v-model="ticket.tickettype"
          readonly
        ></mt-field>
        <div style="position:relative;">
          <mt-field label="抬头类型"></mt-field>
          <my-picker
            :value="ticket.headtype?ticket.headtype.type:''"
            :arr="headtype"
            :vkey="'type'"
            @bindChange="headypeChange"
            :placeholder="'请选择抬头类型'"
          ></my-picker>
        </div>
        <div v-if="ticket.headtype">
          <div v-if="ticket.headtype.type == '个人'">
            <mt-field
              label="姓名"
              placeholder="请输入姓名"
              type="text"
              v-model="ticket.headtype.name"
            ></mt-field>
            <mt-field
              label="手机号码"
              placeholder="请输入手机号码"
              type="tel"
              v-model="ticket.headtype.tel"
            ></mt-field>
            <mt-field
              label="电邮地址"
              placeholder="请输入电子邮箱地址"
              type="email"
              v-model="ticket.headtype.email"
            ></mt-field>
          </div>
          <div v-if="ticket.headtype.type == '单位'">
            <mt-field
              label="名称"
              placeholder="请输入单位名称"
              type="text"
              v-model="ticket.headtype.name"
            ></mt-field>
            <mt-field
              label="联系电话"
              placeholder="请输入联系电话"
              type="tel"
              v-model="ticket.headtype.tel"
            ></mt-field>
            <mt-field
              label="电邮地址"
              placeholder="请输入电子邮箱地址"
              type="email"
              v-model="ticket.headtype.email"
            ></mt-field>
            <mt-field
              label="信用代码"
              placeholder="请输入社会统一信用代码"
              v-model="ticket.headtype.code"
            ></mt-field>
          </div>
        </div>
      </div>
    </div>
    <footer
      style="margin: 15px 0;"
    >
    <mt-button
        @click="submit"
        style="width: 100%; background-color: #1e70e0; color: white">提交订单</mt-button>
      <div style="margin: 15px 0; display: flex; justify-content: space-between;width: 100%;box-sizing:border-box;">
      <mt-button @click="quitCase" type="default" style="width:45%;background-color:#FF0000;color:white;">放弃申请</mt-button>
      <mt-button @click="save" type="default" style="width: 45%"
        >保存</mt-button
      >
      </div>
    </footer>
    <my-preview :src="prevsrc" v-if="showPrev" :value="showPrev" @bindClose="closePrev"></my-preview>
  </div>
</template>
<script>
import picker from "@/components/common/picker.vue";
import preview from "@/components/common/preview.vue";
import reject from "@/components/common/reject.vue";
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
import { MessageBox } from 'mint-ui';
export default {
  components: {
    "my-picker": picker,
    "my-preview":preview,
    "my-reject":reject
  },
  name: "Application",
  data() {
    return {
      showPrev:false,
      prevsrc:"",
      reject_info:[],
      person_info: {
        username: "",
        tel: "",
        cardtype: "",
        cardNo: "",
      },
      trans_file_info: {
        type: "",
        lan: "",
        filesList: [],
        tranbz: "",
      },
      post_info: {
        name: "",
        tel: "",
        address: "",
      },
      ticket: {
        tickettype: "电子普通发票",
        headtype: null,
      },
      lanArr: [
        "英文",
        "韩文",
        "日文",
        "俄文",
        "德文",
        "西班牙文",
        "葡萄牙文",
        "意大利文",
        "瑞典文",
        "捷克文",
        "越南文",
        "泰文",
        "波兰文",
        "塞尔维亚文",
        "法文",
        "荷兰文",
        "葡萄牙文",
        "阿拉伯文",
        "匈牙利文",
        "越南文",
        "印尼文",
        "希伯来文",
        "希腊文",
        "波斯文",
        "马来文",
        "蒙古文",
        "老挝文",
        "尼泊尔文",
        "缅甸文",
        "土耳其文",
        "其他",
      ],
      headtype: [
        { type: "个人", name: "", tel: "", email: "" },
        { type: "单位", name: "", tel: "", email: "", code: "" },
      ],
      cardtypeArr: [
        "国内二代居民身份证",
        "港澳台居民居住证",
        "普通护照",
        "港澳居民来往内地通行证",
        "其他国外证件",
      ],
      trantypeArr: [
        "驾驶证",
        "护照",
        "签证",
        "身份证",
        "结婚证",
        "离婚令",
        "委托书",
        "声明书",
        "产权证",
        "组织机构代码证",
        "其他证明文件",
      ],
      openid: "",
      issm: false,
      caseguid: null,
      caseobj: "",
      caseNumber:null,
    };
  },
  created() {
    this.configapi();
    this.openid = window.localStorage.getItem("openid");
    if (
      this.$CommonFun.getUrlKey("caseguid") != null &&
      this.$CommonFun.getUrlKey("caseguid") != ""
    ) {
      this.caseguid = this.$CommonFun.getUrlKey("caseguid");
      this.getCaseInfo();
    }
  },
  mounted() {},
  methods: {
    //删除附件
    deleImg(id){
      var self = this;
      MessageBox.confirm("是否删除该附件？").then(action=>{
        var caseguid = self.caseguid;
        self.$Api.deleteAddition(caseguid,id)
           .then((res)=>{
                for(var i=0;i<self.trans_file_info.filesList.length;i++){
                  if(self.trans_file_info.filesList[i].guid==id){
                    self.trans_file_info.filesList.splice(i,1)
                    break;
                  }
                }
            })
      })
    },
    //创建新案件
      buildCase(){
        var self=this;
        return new Promise((resolve,reject)=>{
          self.$Api.buildCase().then((res)=>{
                var resdata= res.data.split(";");
                self.caseguid=resdata[0];
                self.caseNumber=resdata[2];
                resolve(true);
            }).catch(reject)
        })
      },
    //预览图片
    /*调用微信预览图片的方法*/
    previewImg(src) {
      this.showPrev=true;
      this.prevsrc=src;
    },
    closePrev(){
      this.showPrev=false;
      this.src="";
    },
    // 验证手机号
    verifyPhone(tel) {
      // var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      var myreg = /^[1][0-9]{10}$/;
      return myreg.test(tel);
    },
    //验证身份证
    verifyID(no) {
      if(this.person_info.cardtype=="国内二代居民身份证"){
      if (no.length < 15 || no.length > 18) {
        return false;
      }
      }
      return true;
    },
    //验证邮箱
    verifyEmail(email) {
      var reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      ); //正则表达式
      return reg.test(email);
    },
    //表单验证
    verifyForm() {
      if (!this.verifyPhone(this.person_info["tel"])) {
        Toast({
          message: "申请人手机号不正确",
          iconClass: "mint-toast-icon mintui mintui-field-error",
        });
        return false;
      }
      if (!this.verifyID(this.person_info["cardNo"])) {
        Toast({
          message: "申请人证件号不正确",
          iconClass: "mint-toast-icon mintui mintui-field-error",
        });
        return false;
      }
      if (!this.verifyPhone(this.post_info["tel"])) {
        Toast({
          message: "收件人手机号不正确",
          iconClass: "mint-toast-icon mintui mintui-field-error",
        });
        return false;
      }
      if (!this.verifyPhone(this.ticket.headtype["tel"])) {
        Toast({
          message: "发票的手机号不正确",
          iconClass: "mint-toast-icon mintui mintui-field-error",
        });
        return false;
      }
      if (!this.verifyEmail(this.ticket.headtype["email"])) {
        Toast({
          message: "发票的邮箱地址不正确",
          iconClass: "mint-toast-icon mintui mintui-field-error",
        });
        return false;
      }
      return true;
    },
    //判断是否填写完整
    checkForm() {
      for (var k in this.person_info) {
        if (this.person_info[k] == "" || this.person_info[k] == null) {
          Toast({
            message: "申请人信息不完整",
            iconClass: "mint-toast-icon mintui mintui-field-error",
          });
          return false;
        }
      }
      for (var k in this.trans_file_info) {
        if (
          this.trans_file_info[k] == "" ||
          this.trans_file_info[k] == null ||
          this.trans_file_info["filesList"].length == 0
        ) {
          Toast({
            message: "翻译信息不完整",
            iconClass: "mint-toast-icon mintui mintui-field-error",
          });
          return false;
        }
      }
      for (var k in this.post_info) {
        if (this.post_info[k] == "" || this.post_info[k] == null) {
          Toast({
            message: "邮寄信息不完整",
            iconClass: "mint-toast-icon mintui mintui-field-error",
          });
          return false;
        }
      }

      if (this.ticket["headtype"] == null) {
        Toast({
          message: "请选择抬头类型",
          iconClass: "mint-toast-icon mintui mintui-field-error",
        });
        return false;
      }
      if (this.ticket["headtype"] != null) {
        for (var k in this.ticket["headtype"]) {
          if (
            this.ticket["headtype"][k] == "" ||
            this.ticket["headtype"][k] == null
          ) {
            Toast({
              message: "发票信息不完整",
              iconClass: "mint-toast-icon mintui mintui-field-error",
            });
            return false;
          }
        }
      }
      return true;
    },
    //取消案件
    quitCase(){
      var self = this;
      //判断是否存在案件号，存在则不须再创建案件，否则要创建案件
        MessageBox.confirm('放弃申请将会删除此订单，确定吗?').then(action=>{
          if(this.caseguid=="" || this.caseguid==null){
            this.buildCase().then((res)=>{
              if(res){
                self.quitApi();
              }
            });
          }else{
            self.quitApi();
          }

        })
    },
    //放弃案件接口
    quitApi(){
      var self=this;
      this.$Api.quitCase(this.caseguid).then((res)=>{
                Toast({
                  message: "操作成功",
                  iconClass: "mint-toast-icon mintui mintui-success",
                  duration: 1000,
                });
                setTimeout(()=>{
                  window.location.href="/";
                },1000)

          })
    },
    //提交案件
    submit() {
      if (!this.checkForm()) return;
      if (!this.verifyForm()) return;
      var self = this;
      //判断是否存在案件号，存在则不须再创建案件，否则要创建案件
          if(this.caseguid=="" || this.caseguid==null){
            this.buildCase().then((res)=>{
              if(res){
                self.updateData()
              }
            }).then((res2)=>{
              if(res2){
                self.submitApi();
              }
            });
          }else{
            self.updateData().then((res)=>{
              if(res){
                self.submitApi();
              }
            })
          }
    },
    submitApi(){
      var self=this;
          MessageBox.confirm("提交后，翻译员将会审核您的申请，立即提交吗？").then(action=>{
            Indicator.open({spinnerType: 'fading-circle'});
            self.$Api.submitCase(self.caseguid)
            .then((res) => {
              Indicator.close();
                Toast({
                  message: "提交成功",
                  iconClass: "mint-toast-icon mintui mintui-success",
                  duration: 1000,
                });
                setTimeout(() => {
                  self.$router.push({ path: "/Examine.html" });
                }, 1000);
            });
          })

    },
    //保存案件
    save() {
      var self=this;
      //判断是否存在案件号，存在则不须再创建案件，否则要创建案件
          if(this.caseguid=="" || this.caseguid==null){
            this.buildCase().then((res)=>{
              if(res){
                self.updateData();
              }
            }).then((res2)=>{
              Toast({
            message: "保存成功",
            iconClass: "mint-toast-icon mintui mintui-success",
            duration: 1000,
          });
          setTimeout(() => {
            self.$router.push({ path: "/History.html" });
          }, 1000);
            });
          }
          else{
            self.updateData().then((res) => {
        if (res) {
          Toast({
            message: "保存成功",
            iconClass: "mint-toast-icon mintui mintui-success",
            duration: 1000,
          });
          setTimeout(() => {
            self.$router.push({ path: "/History.html" });
          }, 1000);
        }
      });
          }

    },
    updateData() {
      var self = this;
      var tickerobj;
      if (this.ticket.headtype) {
        if (this.ticket.headtype.type == "单位") {
          var tickerobj =
            this.ticket.headtype.type +
            "#" +
            this.ticket.headtype.name +
            "#" +
            this.ticket.headtype.code +
            "#" +
            this.ticket.headtype.tel +
            "#" +
            this.ticket.headtype.email;
        }
        if (this.ticket.headtype.type == "个人") {
          var tickerobj =
            this.ticket.headtype.type +
            "#" +
            this.ticket.headtype.name +
            "#" +
            this.ticket.headtype.tel +
            "#" +
            this.ticket.headtype.email;
        }
      }
      return new Promise((resolve, reject) => {
        var info = {
              "案件GUID": self.caseguid, //必填
              "申请人姓名": self.person_info.username,
              "申请人证件类型": self.person_info.cardtype,
              "申请人证件号": self.person_info.cardNo,
              "申请人联系电话": self.person_info.tel,
              "翻译文件类型": self.trans_file_info.type,
              "翻译件语种": self.trans_file_info.lan,
              "翻译备注": self.trans_file_info.tranbz,
              "收件地址": self.post_info.address,
              "收件人姓名": self.post_info.name,
              "收件人电话": self.post_info.tel,
              "电子发票信息": tickerobj, //个人#姓名#电话#邮箱
            };
        self.$Api.updateCase(info).then((res) => {resolve(true);});
      });
    },
    toMiniProgram() {
      this.issm = true;
    },
    cardtypeChange(e) {
      this.person_info.cardtype = e.values;
    },
    trantypeChange(e) {
      this.trans_file_info.type = e.values;
    },
    tranlanChange(e) {
      this.trans_file_info.lan = e.values;
    },
    headypeChange(e) {
      var ht = this.headtype;
      for (var i = 0; i < ht.length; i++) {
        if (e.values.type === ht[i].type) {
          this.ticket.headtype = ht[i];
        }
      }
    },
    //选择图片
    chooseImg() {
      // this.wxUploadPic();
      var self = this;
      wx.chooseImage({
        count: 9, // 默认9
        sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ["album", "camera"], //是相机
        success: function (res) {
          let localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          if (localIds.length > 0) {
            Indicator.open({text:"正在上传中...",spinnerType: "fading-circle",});
            self.readImg(localIds);
          }
        },
      });
    },
    async readImg(localIds){
      var self = this;
      var num=0;
      for(var i=0;i<localIds.length;i++){
        // Indicator.close();
        // Indicator.open({text:"已上传("+Number(num)+"/"+localIds.length+")",spinnerType: "fading-circle",});
        await self.wxUploadPic(i,localIds[i]).then(res=>{
          self.getImg(res).then(res2=>{
            self.trans_file_info.filesList.push(res2);
            num++;
            if(num==localIds.length){
              Indicator.close();
            }
          })
        }).catch(err => {
          alert(`上传错误：\n\n${typeof err == 'object' ? JSON.stringify(err) : err}`);
        });
      }
    },
    wxUploadPic(i,localId) {
      var self = this;
      return new Promise((resolve,reject)=>{
        wx.getLocalImgData({
          localId: localId.toString(),
          success: async function (resp) {
            const localData = resp.localData;
            let imageBase64 = localData;
            if (localData.indexOf("data:image") == 0) {
              //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
              imageBase64 = localData.split(',')[1]; // 不需要前缀
            } else {
              //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
              //此时一个正常的base64图片路径就完美生成赋值到img的src中了
              //   imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
              imageBase64 = localData.replace(/\n/g, "");
            }
            if (imageBase64) {
              try {
                //判断是否存在案件号，存在则不须再创建案件，否则要创建案件
                if(self.caseguid=="" || self.caseguid==null){
                  self.buildCase().then(async (res)=>{
                    if(res){
                      resolve(await self.upimg(i,imageBase64));
                    }
                  }).catch(reject);
                }else{
                  resolve(await self.upimg(i,imageBase64));
                }
              } catch(e) {
                console.error('上传错误', e);
                reject(e);
              }

            } else {
              Toast("选择图片出了点问题，请稍后再试下吧");
            }
          },
        });
      })
    },
    //上传图片接口
    upimg(i,imageBase64){
      console.log('开始上传'+i)
      var self=this;
      let info = {
          "案件GUID": self.caseguid,
          "文件全名": new Date().getTime().toString()+'.jpg',
          "附件BASE64": imageBase64,
      }
      return new Promise((resolve,reject)=>{
        self.$Api.uploadAddition(info).then((res) => {
          console.log('上传成功',i)
          resolve(res.data)
        }).catch(reject);
      })
    },
    //配置接口权限
    configapi() {
      var screte="mVSGKrLIRMwcGtHH";
      var dateStr=this.getNowDate();
      var apiSign=this.$Md5(screte+dateStr).toUpperCase();
      // this.$Api.getjssdk(window.location.href.split("#")[0])
      this.$Axios({
        method: "post",
        url: "http://togzs.gzhcxt.com/api/h5/get-sdksignature",
        data: {
          接口签名: apiSign,
          访问URL: window.location.href.split("#")[0],
        },
      })
      .then((res) => {
        if (res.data.data) {
          var dataArr = res.data.data.split(";");
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: dataArr[0], // 必填，公众号的唯一标识
            timestamp: dataArr[1], // 必填，生成签名的时间戳
            nonceStr: dataArr[2], // 必填，生成签名的随机串
            signature: dataArr[3], // 必填，签名，见附录1
            jsApiList: ["chooseImage", "uploadImage", "getLocalImgData"],
          });
        }
      });
    },
    //获取案件信息
    getCaseInfo() {
      var self = this;
      var caseguid = this.caseguid;
      this.$Api.getCaseInfo(caseguid).then((res) => {
        this.caseobj = res.data;
        this.caseguid = caseguid;
        if (
          this.caseobj["电子发票信息"] != null &&
          this.caseobj["电子发票信息"] != ""
        ) {
          var htArr = this.caseobj["电子发票信息"].split("#");
          var tht;
          if (htArr[0] == "个人") {
            tht = {
              type: htArr[0],
              name: htArr[1],
              tel: htArr[2],
              email: htArr[3],
            };
          }
          if (htArr[0] == "单位") {
            tht = {
              type: htArr[0],
              name: htArr[1],
              tel: htArr[2],
              email: htArr[3],
              code: htArr[4],
            };
          }
        }
        this.caseNumber=this.caseobj["案件号"];
        this.person_info = {
          username: this.caseobj["申请人姓名"],
          tel: this.caseobj["申请人联系电话"],
          cardtype: this.caseobj["申请人证件类型"],
          cardNo: this.caseobj["申请人证件号"],
        };
        this.trans_file_info = {
          type: this.caseobj["翻译文件类型"],
          lan: this.caseobj["翻译件语种"],
          filesList: [],
          tranbz: this.caseobj["翻译备注"],
        };
        this.post_info = {
          name: this.caseobj["收件人姓名"],
          tel: this.caseobj["收件人电话"],
          address: this.caseobj["收件地址"],
        };
        this.ticket = {
          tickettype: "电子普通发票",
          headtype: tht,
        };
        this.reject_info=JSON.parse(this.caseobj["驳回记录"]);
        var list = JSON.parse(this.caseobj["相关附件"]);
        Indicator.open({spinnerType: 'fading-circle'});
        var arr=[];
        for (var i = 0; i<list.length; i++) {
          arr.push(this.getImg(list[i]["附件GUID"]));
        }
        Promise.all(arr).then(res=>{
          Indicator.close();
          self.trans_file_info.filesList=res;
        })
      });
    },
    //获取图片
    async getImg(imgguid) {
      let n = await this.requestImg(imgguid);
      return n;
    },
    requestImg(imgguid){
      var self = this;
      return new Promise((resolve,reject)=>{
          self.$Api.getAdditionInfo(imgguid).then(res=>{
        resolve({'url':"data:image/jpeg;base64," + res.data.base64,'guid':res.data["附件GUID"]})
      });
      });
    },
    //获取当前年月日
    getNowDate() {
    let date = new Date();
    let y = date.getFullYear().toString();
    let m = (date.getMonth() + 1).toString();
    let d = date.getDate().toString();
          m = m < 10 ? "0" + m : m;
          d = d < 10 ? "0" + d : d;
          return y + m + d ;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/my-mint.scss";
</style>

<style scoped>
.big-ceil{
padding-top: 15px;
border-top: 1px solid #c8c8cd;
margin-left: 10px;
}
#text-area {
  width: 90%;
  box-sizing: border-box;
  margin: 10px;
  border-color: #c8c8cd;
  line-height: 1.5;
  padding: 5px;
}
.pop-sm {
  width: 100%;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
h5 {
  margin: 10px auto;
}
.Application {
  text-align: left;
}
.subtitle {
  border-left: 4px solid #1e70e0;
  padding-left: 15px;
  margin: 8px 0 8px 0;
  color: #666;
}
.tips {
  font-size: 12px;
  color: #575757;
  padding: 0 0 15px 15px;
}
.tips span {
  color: #d02424;
}
.img-content {
  padding: 10px 5px;
}
/* .img-content, */
.imglist {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.imglist img{
  margin: 0 5px;
}
.photo-icon {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Application.vue